var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -45 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m472 313.882812v-205.765624c23.058594-6.558594 40-27.832032 40-53.007813 0-30.386719-24.671875-55.109375-55-55.109375s-55 24.722656-55 55.109375c0 25.175781 16.941406 46.449219 40 53.007813v92.882812h-172v-92.882812c23.058594-6.558594 40-27.832032 40-53.007813 0-30.386719-24.671875-55.109375-55-55.109375s-55 24.722656-55 55.109375c0 25.175781 16.941406 46.449219 40 53.007813v92.882812h-144.570312c-14.023438 0-25.429688-11.40625-25.429688-25.429688v-67.453124c23.058594-6.558594 40-27.832032 40-53.007813 0-30.386719-24.671875-55.109375-55-55.109375s-55 24.722656-55 55.109375c0 25.175781 16.941406 46.449219 40 53.007813v67.453124c0 30.566407 24.863281 55.429688 55.429688 55.429688h144.570312v82.882812c-23.058594 6.558594-40 27.832032-40 53.007813 0 30.386719 24.671875 55.109375 55 55.109375s55-24.722656 55-55.109375c0-25.175781-16.941406-46.449219-40-53.007813v-82.882812h172v82.882812c-23.058594 6.558594-40 27.832032-40 53.007813 0 30.386719 24.671875 55.109375 55 55.109375s55-24.722656 55-55.109375c0-25.175781-16.941406-46.449219-40-53.007813zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShift);
export default __webpack_public_path__ + "static/media/shift.aff0b3983b193f634381d77faa153bcb.svg";
export { ForwardRef as ReactComponent };